module.exports = __webpack_public_path__ + "media/icons/smartsearch/colors/silver-0f052e8be77c2d68b5c5789f2e6324c3.png";